import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterGreenPoint() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-green-point",
    name: "Painters Green Point",
    location: "Green Point, Cape Town",
    rating: 4.8,
    reviews: 164,
    specialties: ["Residential Painting", "Commercial Painting", "Apartment Complexes", "Maintenance Services"],
    image: "https://public.readdy.ai/ai/img_res/8d4d05fc425a50d7a1df220a9023b99d.jpg",
    verified: true,
    yearsExperience: 15,
    website: "https://paintersgreenpoint.co.za/",
    email: "info@paintersgreenpoint.co.za",
    description: "Painters Green Point is your trusted local painting contractor serving Green Point and surrounding areas in Cape Town. With 15 years of experience, we specialize in residential and commercial painting projects, including apartment complexes, office buildings, and retail spaces. Our team delivers professional results using premium materials and expert techniques. We understand the unique requirements of urban properties and provide comprehensive painting solutions that enhance both aesthetics and property value.",
    services: [
      "Residential House Painting",
      "Commercial Property Painting",
      "Apartment Complex Painting",
      "Interior Painting Services",
      "Exterior Painting & Protection",
      "Roof Painting & Coating",
      "Waterproofing Services",
      "Maintenance Painting",
      "Color Consultation",
      "Emergency Repairs"
    ],
    serviceAreas: ["Green Point", "Sea Point", "Mouille Point", "Waterfront", "De Waterkant", "City Bowl", "Three Anchor Bay"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20modern%20living%20room%20interior%20painted%20by%20professional%20painters%20in%20Green%20Point%20Cape%20Town%2C%20contemporary%20urban%20apartment%20with%20fresh%20white%20walls%2C%20quality%20paint%20finish%2C%20stylish%20furniture%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work&width=400&height=300&seq=greenpoint-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20apartment%20building%20painting%20project%20in%20Green%20Point%20Cape%20Town%2C%20modern%20residential%20complex%20with%20fresh%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20urban%20setting%20with%20mountain%20views%2C%20well-maintained%20property&width=400&height=300&seq=greenpoint-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Commercial%20office%20space%20painting%20in%20Green%20Point%20Cape%20Town%2C%20professional%20painters%20working%20on%20business%20property%20interior%2C%20quality%20commercial%20paint%20finish%2C%20modern%20office%20design%2C%20organized%20work%20site&width=400&height=300&seq=greenpoint-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20kitchen%20interior%20painting%20in%20Green%20Point%20apartment%2C%20fresh%20painted%20walls%20with%20premium%20finish%2C%20contemporary%20kitchen%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=greenpoint-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Residential%20house%20exterior%20painting%20in%20Green%20Point%20Cape%20Town%2C%20professional%20painters%20working%20on%20family%20home%2C%20quality%20residential%20paint%20finish%2C%20urban%20neighborhood%2C%20organized%20professional%20work%20site&width=400&height=300&seq=greenpoint-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Retail%20shop%20interior%20painting%20in%20Green%20Point%20Cape%20Town%2C%20professional%20commercial%20painting%20work%2C%20quality%20finish%20for%20business%20space%2C%20modern%20retail%20design%2C%20clean%20professional%20application&width=400&height=300&seq=greenpoint-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Rachel Thompson",
        rating: 5,
        comment: "Excellent service from Painters Green Point! They painted our entire apartment complex and the results are outstanding. Professional team, great communication, and completed on schedule. Highly recommend!"
      },
      {
        name: "James Wilson", 
        rating: 5,
        comment: "Very impressed with the quality of work. They painted our Green Point office and were respectful of our business operations. Clean, efficient, and the finish is perfect."
      },
      {
        name: "Sarah van Niekerk",
        rating: 4,
        comment: "Great attention to detail and very professional. Our home looks amazing after their work. Good value for money and would definitely use them again."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Green Point | Professional Painting Services Cape Town | Residential & Commercial Painters";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Green Point offers professional painting services for residential and commercial properties in Green Point, Cape Town. Specializing in apartments, offices, and maintenance services. 15+ years experience. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Green Point, house painters Green Point, painting contractors Cape Town, apartment painting, commercial painting services');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20modern%20apartment%20building%20in%20Green%20Point%20Cape%20Town%2C%20vibrant%20urban%20neighborhood%20with%20iconic%20Table%20Mountain%20backdrop%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20contemporary%20architecture%2C%20bright%20natural%20lighting%2C%20high%20quality%20residential%20painting%20project&width=1200&height=600&seq=greenpoint-painters-hero-main&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in Green Point</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Urban Painting Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Green Point is one of Cape Town's most vibrant urban neighborhoods, featuring a diverse mix of residential apartments, commercial properties, and retail spaces. Our team has extensive experience working in this dynamic environment, understanding the unique challenges of urban painting projects. From coordinating with body corporates to managing logistics in busy areas, we handle every aspect professionally and efficiently.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Residential & Commercial Expertise</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Whether you need painting services for your Green Point apartment, family home, office building, or retail space, we have the expertise to deliver exceptional results. Our residential services include everything from single room refreshes to complete home transformations. For commercial clients, we offer flexible scheduling to minimize business disruption and maintain professional standards throughout the project.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Quality Materials & Workmanship</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  We use only premium paints and materials from leading brands, ensuring durability and beautiful finishes that last. Our team consists of skilled painters with years of experience, committed to delivering quality workmanship on every project. We take pride in our attention to detail, from thorough surface preparation to the final coat, ensuring results that exceed expectations.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Comprehensive Service</h3>
                <p className="text-gray-700 leading-relaxed mb-8">
                  Beyond standard painting services, we offer comprehensive solutions including waterproofing, roof coating, color consultation, and ongoing maintenance services. Our goal is to be your trusted painting partner, providing expert advice and reliable service for all your painting needs. We stand behind our work with solid guarantees and excellent customer support.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20apartment%20building%20in%20Green%20Point%20Cape%20Town%2C%20urban%20neighborhood%20setting%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20modern%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=greenpoint-sidebar-image&orientation=landscape"
                      alt="Professional painters Green Point apartment painting services Cape Town residential commercial"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in Green Point</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Residential & Commercial Solutions</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services cover all aspects of residential and commercial projects in Green Point. From apartments and homes to offices and retail spaces, we provide comprehensive solutions that enhance aesthetics and protect your property investment.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} with premium materials and expert application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Interior Painting Services</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Transform your Green Point property with our professional interior painting services. We use premium, low-VOC paints that are safe for your family and provide excellent coverage and durability. Our color consultation services help you choose the perfect palette that complements your space and lifestyle.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We understand the importance of minimizing disruption, especially in apartment buildings and commercial spaces. Our team works efficiently and cleanly, respecting your space and schedule. We can work room by room or coordinate larger projects to suit your needs.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior Painting & Protection</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting in Green Point requires quality materials and expert application to withstand urban conditions. We use premium exterior paints that resist fading, weathering, and pollution. Our comprehensive exterior painting process includes thorough surface preparation, primer application, and multiple coats for maximum protection.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We also offer specialized services such as roof painting, waterproofing, and maintenance programs to keep your property looking its best year-round. Our maintenance services are particularly popular with body corporates and property managers.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in Green Point</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout Green Point and surrounding areas. Each project demonstrates our commitment to quality workmanship and professional service.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">Green Point Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional painting with premium materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout Green Point have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters Green Point</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your Green Point property with professional painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and surrounding areas</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your Green Point painting project. Our experienced team will assess your property and provide detailed recommendations.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
